<template>
  <div class="Jieji">
    <div class="container">
      <h2>考试准备中心</h2>
      <p>助学考试准备中心帮助计划进入职业课程、基础课程、本科课程或者其他课程的国际学生做好考前准备和规划，关注学生可能遇到的每个考试的要素，培训学生如何通过最佳方法和实践在关键考试获得突破和成功。</p>
    </div>
    <div class="kaoshi-fenlei">
      <van-tabs border
                animated
                title-active-color="#263e65">
        <van-tab title="HSK">
          <div class="kaoshi-cont">
            <h3><span>HSK</span>汉语水平考试</h3>
            <p>汉语水平考试（HSK）是一项国际标准化考试，重点考查汉语非第一语言的考生在生活、学习和工作中运用汉语进行交际的能力。</p>
            <p>考试等级包括HSK（一级）、HSK（二级）、HSK（三级）、HSK（四级）、HSK（五级）和HSK（六级）。</p>
          </div>
          <div class="btns">
            <van-row>
              <van-col span="12">
                <a href="/mobile/HSK"
                   class="_btn"
                   style="background-color: #1173cc;">了解更多</a>
              </van-col>
              <van-col span="12">
                <a href="javascript:;"
                   class="_btn"
                   style="background-color: #008dd7;"
                   @click="showForm2 = true">在线报名</a>
              </van-col>
              <van-col span="12">
                <a href="http://zhuxue.net/down/HSK2020.pdf"
                   class="_btn"
                   style="background-color: #bc3053;">资料下载</a>
              </van-col>
              <van-col span="12">
                <a href="javascript:;"
                   class="_btn"
                   style="background-color: #d8a31a;"
                   @click="onShowForm(9,'HSK汉语水平考试')">咨询请联系</a>
              </van-col>
            </van-row>
          </div>
        </van-tab>
        <van-tab title="BCT">
          <div class="kaoshi-cont">
            <h3><span>BCT</span>商务汉语考试</h3>
            <p>商务汉语考试（BCT）作为一项国际汉语能力标准化考试，重点考查第一语言非汉语考生在真实商务或一般工作情境中运用汉语进行交际的能力。</p>
            <p>BCT考试分为笔试和口试两部分，且二者相互独立。笔试包括BCT（A）、BCT（B）。</p>
          </div>
          <div class="btns">
            <van-row>
              <van-col span="12">
                <a href="/mobile/BCT"
                   class="_btn"
                   style="background-color: #1173cc;">了解更多</a>
              </van-col>
              <van-col span="12">
                <a href="javascript:;"
                   class="_btn"
                   style="background-color: #008dd7;"
                   @click="showForm3 = true">在线报名</a>
              </van-col>
              <van-col span="12">
                <a href="http://zhuxue.net/down/BCT2020.pdf"
                   class="_btn"
                   style="background-color: #bc3053;">资料下载</a>
              </van-col>
              <van-col span="12">
                <a href="javascript:;"
                   class="_btn"
                   style="background-color: #d8a31a;"
                   @click="onShowForm(10,'BCT商务汉语考试')">咨询请联系</a>
              </van-col>
            </van-row>
          </div>
        </van-tab>
        <van-tab title="MCT">
          <div class="kaoshi-cont">
            <h3><span>MCT</span>医学汉语水平考试</h3>
            <p>医学汉语水平考试 (MCT) 是一项考查医学汉语应用水平的标准化语言测试，由孔子学院总部、汉考国际联合国内五所重点医学院校共同研制。医学汉语水平考试 (MCT)主要面向医学专业留学生、在中国境外用汉语进行医学专业学习的学生，以及在中国境内外用汉语进行临床诊疗的汉语非第一语言医护工作人员，考查其在医学/医疗场景中与患者、医护人员及相关人员用汉语进行交际的能力。</p>
          </div>
          <div class="btns">
            <van-row>
              <van-col span="12">
                <a href="/mobile/MCT"
                   class="_btn"
                   style="background-color: #1173cc;">了解更多</a>
              </van-col>
              <van-col span="12">
                <a href="javascript:;"
                   class="_btn"
                   style="background-color: #d8a31a;"
                   @click="onShowForm(11,'MCT医学汉语水平考试')">咨询请联系</a>
              </van-col>
            </van-row>
          </div>
        </van-tab>

      </van-tabs>
    </div>
    <div class="container">
      <h2 style="color:#263e65;">考试规则</h2>
      <div class="shenqingTit">考试报名与交费</div>
      <div class="buzhu">
        <van-steps direction="vertical"
                   :active="10">
          <van-step>
            <h3>STEP 1</h3>
            <div class="lis">
              <h4>登陆汉语考试服务网</h4>
              <p>网址 <a href="www.chinesetest.cn">www.chinesetest.cn</a></p>
            </div>
          </van-step>
          <van-step>
            <h3>STEP 2</h3>
            <div class="lis">
              <h4>注册用户</h4>
              <p>注册成为汉语考试服务网用户,记住你的用户名(邮箱)和密码注册用户需要填写Ema地址、国籍、母语和出生日期等信息。</p>
            </div>
          </van-step>
          <van-step>
            <h3>STEP 3</h3>
            <div class="lis">
              <h4>考试报名</h4>
              <p>选择考试级别、考试形式(纸笔考和机网考)、考点和考试时间在报名前,你要先了解所选考点的考试举办形式</p>
            </div>
          </van-step>
          <van-step>
            <h3>STEP 4</h3>
            <div class="lis">
              <h4>填写个人填写</h4>
              <p>你的姓名(与证件一致)性别、出生日期、国籍、证件信息等注意信息的真实性和完整性</p>
            </div>
          </van-step>
          <van-step>
            <h3>STEP 5</h3>
            <div class="lis">
              <h4>上传照片</h4>
              <p>上传100kB以内xG格式的标准证件照(二寸)在中国大陆地区考点报名参加考试的考生,须提交电子照片,如未上传照片或上传照片不符合要求的,将不能进入考场参加考试</p>
            </div>
          </van-step>
          <van-step>
            <h3>STEP 6</h3>
            <div class="lis">
              <h4>确认注册信息</h4>
              <p>核实信息无误后,选择“确认并提交”</p>
            </div>
          </van-step>
          <van-step>
            <h3>STEP 7</h3>
            <div class="lis">
              <h4>支付考试费</h4>
              <p>请在报名截止前完成交费,否则报名无效,考试费支付成功以后,不可以取消考试开通阴上支付的考点,考生可直接进行在线支付</p>
            </div>
          </van-step>
          <van-step>
            <h3>STEP 8</h3>
            <div class="lis">
              <h4>获得报名确认</h4>
              <p>完成报名交费并填写有效Ema信箱的考生,在考试前10天会收到报名确认,未收到的请联系报名考点</p>
            </div>
          </van-step>
          <van-step>
            <h3>STEP 9</h3>
            <div class="lis">
              <h4>领取印准考证</h4>
              <p>登录汉语考试服务网自行打印准考证,或到报名考点领取准考证。考试当天必须携带准考证及有效身份证件原件</p>
            </div>
          </van-step>
        </van-steps>
      </div>
      <div class="shenqingTit">考生照片要求</div>
      <p>汉语考试各级别均应按以下要求提供照片。其中HSK3-6级、HSKK、BCT和YCT口试的照片还将用于成绩报告印刷。</p>
      <p>照片样式要求：</p>
      <p>- 本人近期证件照（标准二寸），不可以是生活照、风景照</p>
      <p>- 请勿佩戴帽子、头巾、发带、墨镜（有特殊宗教信仰的除外）；</p>
      <p>- 黑白或彩色照片均可，以白色背景为佳</p>
      <p>考生登录汉语考试服务网，按照网站指导上传电子照片，或者将电子照片交给考点负责报名的老师，请报名老师协助上传。</p>
      <div class="shenqingTit">准考证</div>
      <p>准考证内容包括考生姓名、国籍、性别、证件类型和号码、考试科目、考试时间、考点名称、考试地点、考场须知等。</p>
      <p>考生收到准考证后请仔细检查准考证上各项信息是否准确无误。准考证上所填姓名、性别、出生日期及证件号码必须与有效证件一致，否则不得参加考试。</p>
      <p>如果准考证上信息有误，请联系考点更改，否则考试无效。</p>
      <p>准考证是考生入场参加考试的重要证明，未携带准考证的考生不得入场参加考试。考试结束以后考生需要继续保存准考证，在领取成绩报告时需要提供准考证。在网上查询成绩和申请额外成绩报告等增值服务时也需要提供准考证号码。</p>
      <div class="shenqingTit">更改考试日期</div>
      <p>考生完成报名和交费后，可以在规定的时间内申请更改考试日期，但不可以取消报名，已经报名的考试地点和考试级别不可以更改。单次报名只接受一次更改考试日期要求。</p>
      <p>考生需要通过汉语考试服务网（www.chinesetest.cn），登录“个人中心”申请更改考试日期，可更改的考试日期为报名考点当年度举办的任何一次相同级别的考试。</p>
      <p>更改考试日期的时限与费用如下：</p>
      <p>• 考试前27天（含第27天）：考生可以免费更改，不收取费用。</p>
      <p>• 考试前27天到考试前10天（含第10天）：考生在此期间申请更改，须事先交纳金额为考试费30%的更改手续费。</p>
      <p>• 考试前10天以内（不含第10天）：不再接受更改申请。</p>
      <p>注意：以上规则同时适用于纸笔考试和网络考试。</p>
      <div class="shenqingTit">考试规则</div>
      <p class="ted0"><b>1. 考试用品</b></p>
      <p>考试当天，考生进场时必须携带：</p>
      <p>- 准考证</p>
      <p>- 与报名一致的、真实有效且带照片的个人身份证件（复印件无效）</p>
      <p>- 参加纸笔考试须携带2B铅笔（两支以上）和橡皮</p>
      <p>考生其它个人物品须放在主考老师指定的物品存放处，不可以随身携带。请勿携带贵重物品前往考场，否则遗失恕不负责。</p>
      <p>考生入场时无法提供符合规定的证件和准考证，将不能参加考试。考试费用不予退还。</p>
      <p class="ted0"><b>2. 入场时间</b></p>
      <p>考生应在开考前半小时到达考场，避免迟到。入场后直到听力考试结束前，考生不得出入考场。</p>
      <p>纸笔考试：听力考试开始前，迟到的考生可进入考场参加考试；听力考试开始后，迟到的考生须等听力考试结束后才可进入考场参加阅读考试，所误时间不补；阅读考试开始后，迟到的考生不得进入考场参加考试。</p>
      <p>口语考试：录音开始前，迟到的考生可进入考场参加考试，所误时间不补；录音开始后，迟到的考生不得进入考场参加考试。</p>
      <p class="ted0"><b>4. 考试规则</b></p>
      <p>(1) 考生必须坐在指定的座位上，考生无权选择座位。</p>
      <p>(2) 考生须听从主考指令，遵守考试规则，并独立完成各项考试。</p>
      <p>(3) 考试中间没有休息时间，如有特殊原因，考生需要中途离场，须经主考同意，在离开考场前把准考证和身份证件交给监考人员,考生返回考场后，监考人员返还考生准考证和身份证件。</p>
      <p>(4) 口语考试中考生不得暂时离开考场，若要离开，只能退出考试。</p>
      <p class="ted0"><b>5. 突发情况处理</b></p>
      <p>(1) 由于考场管理失误造成考生受到不公平待遇，例如：考试时间不足、考卷损坏、考试设备损坏等，导致考生无法完成考试，汉考国际将尽快安排考生免费重新参加考试，不承担任何间接损失补偿，考试地点不能变更。</p>
      <p>(2) 由于不可抗力，例如：自然灾害、意外事故，迫使考试无法进行，汉考国际将尽快安排重试，或全额退回考试费用，不承担任何间接损失补偿。</p>
      <p class="ted0"><b>6. 考生缺考</b></p>
      <p>如果考试当天考生因非考试主办方原因没有参加考试，考试费不予返还。</p>
      <p class="ted0"><b>7. 违规与处罚</b></p>
      <p>考生不得提前打开试卷、跨区做题，不能撕扯、更换、抄录试卷内容，不能把试卷和答案带出考场，如果考生存在作弊、替考、抄袭、夹带及不听从考官指令等行为，考试成绩将被取消。</p>
      <div class="shenqingTit">考试成绩</div>
      <p class="ted0"><b>1. 成绩查询</b></p>
      <p>网络考试结束后两周，纸笔考试结束后一个月考生可以登录汉语考试服务网（www.chinesetest.cn），输入准考证号码和姓名查询成绩。</p>
      <p class="ted0"><b>2. 成绩报告</b></p>
      <p>中国大陆地区考生，请在考试成绩公布后在线填写指定地址，申请诊断分析和成绩报告寄送服务（成绩报告申请）。其他地区考生的成绩报告会在考后1－2个月内寄送到考点，考生可凭准考证和身份证件到考点领取。</p>
      <p class="ted0"><b>3. 成绩报告的有效期</b></p>
      <p>汉语考试成绩有效期为两年（从考试当日算起）。</p>
      <div class="shenqingTit">考后附加服务</div>
      <p class="ted0"><b>1. 额外成绩报告寄送服务</b></p>
      <p>为方便考生将汉语水平考试成绩报告作为申请学校、毕业证明、应聘、晋升等汉语能力的证明，考生可通过汉语考试服务网(www.chinesetest.cn)申请额外成绩报告寄送。申请方式和收费标准请登录汉语考试服务网（www.chinesetest.cn）查询。</p>
      <p class="ted0"><b>2. 成绩报告修改服务</b></p>
      <p>汉语水平考试成绩报告为考生汉语能力的重要证明，由于部分考生在网上或考点现场报名时，未按要求仔细核对信息，报名完成后，未认真核对报名确认函和准考证，导致成绩报告上的个人信息与真实情况不符。为不影响成绩报告正常使用，考生可通过汉语考试服务网（www.chinesetest.cn）申请成绩报告修改服务。</p>
      <p>成绩报告修改服务申请条件:</p>
      <p>(1) 申请修改的信息仅限于下面几种情况：</p>
      <p>• 姓名拼写错误</p>
      <p>• 国籍信息错误</p>
      <p>• 性别信息错误</p>
      <p>(2) 考生需提供相关证明文件，如护照、身份证。</p>
      <p>(3) 成绩报告修改申请须在成绩报告有效期内提出（考试结束后两年以内）。</p>
      <p class="ted0"><b>3. 成绩复议服务</b></p>
      <p>为满足考生需求，解答考试疑问，即日起考生可登录汉语考试服务网个人中心申请成绩复议服务。复议服务申请时限为考试成绩公布后30天内。成绩复议申请一旦提交成功无法取消或修改复议项目。成绩复议期间，考生成绩将被冻结，不得用于学术、工作、奖学金申请。在此期间考生无法在线查询成绩，或申请额外成绩报告。</p>
    </div>
    <div class="botline">
      没有更多了
    </div>
    <van-popup v-model="showForm"
               position="bottom"
               @closed="clearForm"
               :style="{ height: 'max-contant',maxHeight:'70%' }">
      <div class="FormCont">
        <ComForm @hideForm="hideForm"
                 :typeId=formType
                 :formTitle="formtit"
                 ref="comForm"></ComForm>
      </div>
    </van-popup>
    <van-popup v-model="showForm2"
               position="bottom"
               @closed="clearForm"
               :style="{ height: 'max-contant',maxHeight:'70%' }">
      <div class="FormCont">
        <HSKForm @hideForm="hideForm"
                 ref="HSKForm"></HSKForm>
      </div>
    </van-popup>
    <van-popup v-model="showForm3"
               position="bottom"
               @closed="clearForm"
               :style="{ height: 'max-contant',maxHeight:'70%' }">
      <div class="FormCont">
        <BCTForm @hideForm="hideForm"
                 ref="BCTForm"></BCTForm>
      </div>
    </van-popup>
  </div>
</template>

<script>
// @ is an alias to /src
import ComForm from '@/components/ComForm'
import HSKForm from '@/components/HSKForm'
import BCTForm from '@/components/BCTForm'

export default {
  name: 'Jieji',
  components: {
    ComForm,
    HSKForm,
    BCTForm
  },
  data () {
    return {
      activeNames: ['0'],
      showForm: false,
      showForm2: false,
      showForm3: false,
      formtit: '',
      formType: ''
    }
  },
  methods: {
    hideForm () {
      this.showForm = false
      this.showForm2 = false
      this.showForm3 = false
    },
    clearForm () {
      this.$refs.comForm.clearForm()
    },
    onShowForm (id, val) {
      this.formType = id
      this.formtit = val
      this.showForm = true
    }
  }
}
</script>

<style lang="scss" scoped>
.Jieji {
  height: 100%;
  overflow: auto;
}
h2 {
  text-align: center;
}
p {
  margin-bottom: 20px;
  font-size: 28px;
  text-indent: 2em;
  &._c {
    text-align: center;
    text-indent: 0;
  }
  &.ted0 {
    text-indent: 0;
  }
}
.container {
  padding-bottom: 0;
  h4 {
    margin: 0;
  }
  font-size: 28px;

  .tips {
    color: #f29810;
    margin: 10px 0;
  }
  .tips_p {
    color: #545454;
  }
  .tips_lis {
    margin-top: 10px;
    color: #545454;
  }
  .tit1 {
    font-size: 32px;
    font-weight: bold;
    color: #f29810;
    text-align: center;
    margin-bottom: 20px;
  }
  .buzhu {
    h3 {
      margin-bottom: 20px;
      color: #263e65;
    }
    .lis {
      padding: 20px;
      box-shadow: 0px 0px 10px rgba($color: #000000, $alpha: 0.2);
    }
    p {
      text-indent: 0;
      margin: 0;
      margin-top: 20px;
      color: #545454;
      font-size: 26px;
      a {
        color: #263e65;
      }
    }
  }
  .shenqingTit {
    border-left: 10px solid #263e65;
    line-height: 1;
    font-size: 32px;
    margin: 30px 0;
    padding-left: 10px;
  }
}

.cont-card {
  padding: 20px 0;
}

._baoming {
  padding: 20px;
  p {
    text-indent: 0;
    text-align: center;
  }
}
._lis {
  box-shadow: 0px 0px 10px rgba($color: #000000, $alpha: 0.2);
  border-radius: 15px;
  margin-bottom: 40px;
  overflow: hidden;
  .text {
    padding: 20px;
    h5 {
      font-size: 36px;
      margin: 0;
      margin-bottom: 20px;
      color: #333;
    }
    p {
      text-indent: 0;
      color: #545454;
    }
  }
}
.kaoshi-fenlei {
  .kaoshi-cont {
    padding: 20px;
    h3 {
      font-size: 32px;
      margin-bottom: 20px;
      span {
        font-size: 58px;
        color: #263e65;
        margin-right: 10px;
      }
    }
    p {
      text-indent: 0;
      color: #545454;
    }
  }
  .btns {
    ._btn {
      display: block;
      background-color: #f6cb47;
      color: #fff;
      border-radius: 10px;
      padding: 20px 0;
      text-align: center;
      margin: 0 auto;
      margin-top: 20px;
      width: 95%;
    }
  }
}
</style>
<style lang="scss">
.van-step--finish .van-step__circle,
.van-step--finish .van-step__line {
  background-color: #263e65;
}
</style>
